import React, { useState, useEffect, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { NavmenuItemsData } from "../header/NavbarMenuData";
import { getClientData } from "../../utils/Common";
import { FaArrowUp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import makeRequest from "../../utils/makeRequest";
import * as urls from "../../utils/URLConst";
import { handleInvoiceDtl, handleLoader } from "../../redux/reducers/layout";
import InvoiceDetailTableModal from "../modal/InvoiceDetailTableModal";
import toastNotify from "../../utils/ToastNotify";
import { BiPowerOff, BiStar, BiUser } from "react-icons/bi";

const Header = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const invoiceDtl = useSelector((state) => state.layout.invoiceDtl);
  const dispatch = useDispatch();
  const [isDueInvoiceMdl, setIsDueInvoiceMdl] = useState(false);
  const [dueInvoiceData, setDueInvoiceData] = useState([]);
  const navigate = useNavigate();

  const handleIsDueInvoiceMdl = () => {
    setIsDueInvoiceMdl(!isDueInvoiceMdl);
  }

  async function fetchInvoiceDtl() {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.getDueInvoicePayment, {}, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE[0];
        dispatch(handleInvoiceDtl(response));
      } else {
        toastNotify(result.Message, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function fetchDuePaymentInvoices() {
    try {
      dispatch(handleLoader(true));
      if (invoiceDtl?.DUE_AMT === "0.00") {
        return toastNotify("You haven't any outstanding invoice.", "success");
      }

      const result = await makeRequest("POST", urls.getDuePaymentDetails, {}, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        handleIsDueInvoiceMdl();
        setDueInvoiceData(response);
      } else {
        toastNotify(result.Message, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useMemo(() => {
    (async () => {
      await fetchInvoiceDtl();
    })();
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 350);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const PERSON_NM = getClientData()?.PERSON_NM;
  const LAST_LOGIN = getClientData()?.LAST_LOGIN;
  const Client_data = getClientData();

  useEffect(() => {
    document.title =
      "CRMS | User Name : " + PERSON_NM + " | Last Login: " + LAST_LOGIN;
  }, []);

  async function logout() {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.logout, {}, {});
      if (result.STATUS === "0") {
        navigate("/");
        toastNotify(result.MESSAGE, "success");
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  return (
    <div>
      <div className="layout-navbar-full layout-horizontal layout-without-menu layout-position">
        <nav
          className="layout-navbar navbar navbarStyle navbar-expand-xl align-items-center bg-navbar-theme"
          id="layout-navbar"
        >
          <div className="container-xxl">
            <div className="navbar-brand app-brand demo d-none d-xl-flex py-0">
              <NavLink to="dashboard" className="app-brand-link gap-2">
                <span className="app-brand-text demo menu-text fw-bolder">
                  <img
                    src="/assets/images/logo3.png"
                    alt="logo"
                    style={{
                      width: 130,
                    }}
                  />
                </span>
              </NavLink>
            </div>

            {/* For mobile view  */}
            <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0  d-xl-none">
              <NavLink to="dashboard" className="app-brand-link gap-2">
                <span className="app-brand-text demo menu-text fw-bolder">
                  <img
                    className="imgLogo"
                    src="/assets/images/logo3.png"
                    alt="logo"
                    style={{
                      width: 130,
                    }}
                  />
                </span>
              </NavLink>
            </div>
            <div
              className="navbar-nav-right d-flex align-items-center"
              id="navbar-collapse"
            >
              <li className="nav-item me-2 me-xl-0 flex-column border-start border-white d-none d-md-block justify-content-start px-4">
                <p className="d-none d-md-block fw-semibold mb-0 fs-6">
                  Welcome, <span>{Client_data?.COMPANY_NM}</span>
                </p>

                <p className="d-none d-md-block mb-0 text-xs">
                  Last Login :{" "}
                  {Client_data
                    ? Client_data?.LAST_LOGIN
                    : "You Are First Time Login"} {Number(invoiceDtl?.DUE_AMT) > 0 && <> | <span className="text-danger fw-semibold outstanding-amount-text" title="Due Payment Invoices" onClick={fetchDuePaymentInvoices}>Outstanding Amount : {invoiceDtl?.DUE_AMT}</span></>}
                </p>
              </li>

              <ul className="navbar-nav flex-row align-items-center ms-auto">
                <li className="nav-item navbar-dropdown dropdown-user dropdown">
                  <a
                    className="nav-link dropdown-toggle hide-arrow"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-2">
                        <div
                          className="avatar"
                          style={{ width: "2rem", height: "2rem" }}
                        >
                          <img
                            src="./assets/images/profile.png"
                            alt=""
                            className="h-auto rounded-circle border"
                            title="Profile"
                          />
                        </div>
                      </div>

                      <div
                        className="fw-normal d-block"
                        style={{
                          textWrap: "wrap",
                          textAlign: "start",
                          textTransform: "capitalize",
                        }}
                      >
                        {PERSON_NM}
                      </div>
                    </div>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li className="border-bottom">
                      <NavLink className="dropdown-item  profile-Menu" to="user-profile">
                        <BiUser className="text-lg me-2" />
                        <span style={{ fontWeight: "400" }}>Profile</span>
                      </NavLink>
                    </li>
                    <li className="border-bottom">
                      <NavLink className="dropdown-item  profile-Menu" to="/review">
                        <BiStar className="text-lg me-2" />
                        <span style={{ fontWeight: "400" }}>Feedback</span>
                      </NavLink>
                    </li>
                    <li>
                      <div className="dropdown-item text-danger logOut-menu"
                        onClick={logout}
                      >
                        <BiPowerOff className="text-lg me-2" />
                        <span style={{ fontWeight: "400" }}>Log Out</span>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <aside
          id="layout-menu"
          className="layout-menu-horizontal menu-horizontal menu bg-menu-theme flex-grow-0 d-block"
        >
          <div className="container-xxl d-flex h-100">
            <ul className="scrollmenu menu-inner">
              {NavmenuItemsData.map((item, i) => {

                const { Icon } = item;

                return (
                  <li className="menu-item p-1" key={i}>
                    {!item.isChild && (
                      <div className="Menuactive">
                        <NavLink className="menu-link" to={item.url}>
                          <div
                            className="hide-menu"
                            style={{ marginLeft: "2px" }}
                          >
                            <Icon /> {item.title}
                          </div>
                        </NavLink>
                      </div>
                    )}
                  </li>
                )
              })}
            </ul>
          </div>
        </aside>
        {showScrollButton && (
          <button
            className="btn btn-light btn-outline-btn btn-floating"
            onClick={handleScrollToTop}
            style={{
              position: "fixed",
              bottom: "100px",
              right: "40px",
              fontSize: "15px",
              padding: "10px 10px",
              borderRadius: "50%",
            }}
          >
            <FaArrowUp />
          </button>
        )}
      </div>


      {isDueInvoiceMdl && (
        <InvoiceDetailTableModal
          data={dueInvoiceData}
          isOpen={isDueInvoiceMdl}
          handleInvoiceMdl={handleIsDueInvoiceMdl}
        />
      )}
    </div>
  );
};

export default Header;
